import React from 'react';
import { connect } from "react-redux";
import * as fileCrud from '../../../../crud/file.crud';
import Document from '../../_CustomComponents/DocumentV2';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import { Alert } from "react-bootstrap";
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import moment from 'moment';
import { FormattedMessage, injectIntl } from "react-intl";
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import { withSnackbar } from 'notistack';
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';


// const replyOptionsCE = [
//     { value: 1, display: 'Accepted' },
//     { value: 0, display: 'Not Accepted - Consultant to Resubmit' },
//     { value: 3, display: 'Not Accepted - SM to make own Assessment' },
// ];
// const replyOptionsINS = [
//     { value: 1, display: 'Accepted' },
//     { value: 0, display: 'Not Accepted - Consultant to Resubmit' },
//     { value: 3, display: 'Not Accepted - SM to make own Assessment' },
//     { value: 5, display: 'Not Accepted - Decision will not be given' },
// ];

// const proceedOptions = [
//     { value: '61.1', display: '61.1 Consultant is instructed to proceed with works' },
//     { value: '61.2', display: '61.2 Consultant is instructed to NOT proceed with works until instructed' },
// ];
// const replyOptionsDefault = [1, 0, 3];
// const replyOptionsCLAIMS = [1, 0, 3, 5];
// const replyOptionsCWN = [8, 5];

class ReplyDocument extends BaseDocument {
    constructor(props) {
        super(props);
        const { replyFields } = this.props.workflowItem;
        console.log()
        // #region QUOTE REPLY OPTIONS
        let replyOptionsPlaceholderName = "";
        //PROPOSED INSTRUCTION
        if (props.notificationType === '612PM') {
            replyOptionsPlaceholderName = "InstructionReplyOpts";
        }
        //SUPPLIER CLAIMS WITH QUOTATION
        else if (props.mode === 'CLAIM') {
            replyOptionsPlaceholderName = "SupplierCWQReplyOpts";
        }
        //SUPPLIER COMPENSATION EVENTS SHORT TERM
        else if (props.mode === 'SHORT') {
            replyOptionsPlaceholderName = "SupplierShortCENReplyOpts";
        }
        //SUPPLIER/CLIENT CLAIMS WITH NOTICE 
        else if (props.mode === 'CLAIMWN' || props.mode === 'CLIENTCWN') {
            if (props.notification.continuingeffect === 1) {
                replyOptionsPlaceholderName = "InterimQuoteReplyOpts";
            }
            else {
                replyOptionsPlaceholderName = "CWNQuoteReplyOpts";
                // if (props.placeholdersQA.SupplierCWNReplyOpts) {
                //     //SUPPORT HISTORIC
                //     replyOptionsPlaceholderName = "SupplierCWNReplyOpts";
                // }
            }
        }
        //PM COMPENSATION EVENTS
        else if (props.mode === 'PM') {
            replyOptionsPlaceholderName = "PMCENReplyOpts";
        }
        //SUPPLIER COMPENSATION EVENTS
        else if (props.mode === 'SUPPLIER') {
            replyOptionsPlaceholderName = "SupplierCENReplyOpts";
        }
        else if (props.mode === 'CLIENT') {
            replyOptionsPlaceholderName = "ClientQuoteReplyOpts";
        }
        else if (this.props.parentWorkflowItem.id === 84) {
            replyOptionsPlaceholderName = "SupplierPropQuoteReplyOpts";
        }

        if (!replyOptionsPlaceholderName) {
            this.props.enqueueSnackbar("UNKNOWN REPLY OPTIONS", { variant: "error" });
        }
        if (!props.placeholdersQA[replyOptionsPlaceholderName]) {
            this.props.enqueueSnackbar(`Placeholder missing: ${replyOptionsPlaceholderName}`, { variant: "error" });
        }
        const replyOptionIDsSelected = props.placeholdersQA[replyOptionsPlaceholderName].values
            .filter(item => item.isActive === true)
            .map(item => Number(item.field));
        //#endregion



        this.quoteStatuses = props.quoteStatuses.map(x => ({ value: +x.field, display: x.display }))
            .filter(y => replyOptionIDsSelected.includes(y.value))
            .sort((a, b) => a.display.localeCompare(b.display));


        this.replyFormConfig = {
            currencyCode: this.props.contract.currency,
            fields: []
        };
        if (replyFields.ReplyAmount.visible) {
            this.replyFormConfig.fields.push({ label: replyFields.ReplyAmount.label, editorType: 'dxNumberBox', dataField: 'amount', value: () => props.notification.amount, required: false });
        }
        if (replyFields.ReplyDays.visible) {
            this.replyFormConfig.fields.push({ label: replyFields.ReplyDays.label, dataField: 'days', editorType: 'dxNumberBox', editorOptions: { format: '#,##0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }) }, value: () => props.notification.days, required: false });
        }
        if (replyFields.ReplyStatus.visible) {
            this.replyFormConfig.fields.push({ label: replyFields.ReplyStatus.label, dataField: 'responsestatus', editorType: 'dxSelectBox', editorOptions: { dataSource: this.quoteStatuses, valueExpr: 'value', displayExpr: 'display' } });
        }
        if (replyFields.ReplyProceed.visible) {
            this.replyFormConfig.fields.push({ label: replyFields.ReplyProceed.label, dataField: 'proceed', editorType: 'dxSelectBox', editorOptions: { dataSource: replyFields.ReplyProceed.proceedOptions, valueExpr: 'field', displayExpr: 'display' }, visible: (obj) => obj.responsestatus !== 5 });
        }
        if (replyFields.ReplyComment.visible) {
            this.replyFormConfig.fields.push({ label: replyFields.ReplyComment.label, dataField: 'responsecomment', editorType: 'dxHtmlEditor' });
        }
    }




    renderForm = () => {
        return (
            <>
                {
                    this.props.notificationType === '612PM' && this.props.resources.InstructionQuoteReplyWarningBanner && (
                        <Alert variant="warning" >
                            <p>
                                {this.props.resources.InstructionQuoteReplyWarningBanner}
                            </p>
                        </Alert>
                    )
                }
                {
                    this.props.notificationType !== '612PM' && this.props.resources.QuoteReplyWarningBanner && (
                        <Alert variant="warning" >
                            <p>
                                {this.props.resources.QuoteReplyWarningBanner}
                            </p>
                        </Alert>
                    )
                }
                <BiDynamicForm
                    isReply={true}
                    item={this.props.reply}
                    config={this.replyFormConfig}
                    valueChangeHandler={this.props.fieldChanged}
                    customFields={(this.props.customFieldsCommon || {}).QUOTE_REPLY}
                    secondaryPriceSectionEnabled={true}
                    secondaryDateSectionEnabled={true}
                />
            </>
        );
    }
    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType + 'Reply', this.props.notification.quotationid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }
    render() {
        const documentIsFinal = !this.props.isAwaitingReply;
        const { replycreatebyname, replycreatedate, draftreplyby, draftreplydate, draftreplyto } = this.props.notification;
        if (documentIsFinal && !this.props.notification.pdfreplyjsoncontent) {
            //QUOTE REPLY IS ASSIGNED BECAUSE OTHER QUOTE ACCEPTED OR REJECTED DEFINITLY
            //THERE IS NO ACTUAL RESPONSE CONTENT TO SHOW
            return (
                <Portlet>
                    <PortletBody style={{ maxWidth: 800 }}>
                        <Alert variant="warning">
                            <p>
                                <FormattedMessage id="GENERAL.NO_DOC_CONTENT" />
                            </p>
                        </Alert>
                    </PortletBody>
                </Portlet>
            );
        }
        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={replycreatebyname}
                    createdate={replycreatedate}
                    lastdraftedbyname={draftreplyby}
                    lastdrafteddate={draftreplydate}
                    lastdraftednotifiedtoname={draftreplyto}
                    isReply={true}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfreplyjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.compensationreference}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    isReply={true}
                    customFields={(this.props.customFieldsCommon || {}).QUOTE_REPLY}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.compensation.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                    quoteref={this.props.notification.referenceid}
                />
            </>
        );

    }
}

const mapStateToProps = store => ({
    // globalResources: store.contract.template.resources,
    // contract: store.contract.contract,
});

export default withSnackbar(injectIntl(connect(mapStateToProps)(ReplyDocument)));
